module.exports = __webpack_public_path__ + "img/WLPLogo.14d2dc8a.png";